export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14280.9ab5c834.jpg";